// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum IxkeinePrinterSetupExeResultAction {
    eErstellen = 0,
    eDrucken = 1,
    eLokalAblegen = 2,
    eDruckenUndLokalAblegen = 3,
    eEMailAnMich = 4,
}

export const IxkeinePrinterSetupExeResultActionLabels: {[k: string]: string} = {
    [IxkeinePrinterSetupExeResultAction.eErstellen]: t('processprintersetupparaminterface:enum.IxkeinePrinterSetupExeResultAction.eErstellen'),
    [IxkeinePrinterSetupExeResultAction.eDrucken]: t('processprintersetupparaminterface:enum.IxkeinePrinterSetupExeResultAction.eDrucken'),
    [IxkeinePrinterSetupExeResultAction.eLokalAblegen]: t('processprintersetupparaminterface:enum.IxkeinePrinterSetupExeResultAction.eLokalAblegen'),
    [IxkeinePrinterSetupExeResultAction.eDruckenUndLokalAblegen]: t('processprintersetupparaminterface:enum.IxkeinePrinterSetupExeResultAction.eDruckenUndLokalAblegen'),
    [IxkeinePrinterSetupExeResultAction.eEMailAnMich]: t('processprintersetupparaminterface:enum.IxkeinePrinterSetupExeResultAction.eEMailAnMich'),
}

export const ixkeinePrinterSetupExeResultActionToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in IxkeinePrinterSetupExeResultAction) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(IxkeinePrinterSetupExeResultActionLabels[IxkeinePrinterSetupExeResultAction[x as keyof typeof IxkeinePrinterSetupExeResultAction]]),
            value: IxkeinePrinterSetupExeResultAction[x as keyof typeof IxkeinePrinterSetupExeResultAction],
        })
    }

    return opts
}
